export { default as IntlContext } from './IntlContext';
export { default as IntlProvider } from './IntlProvider';
export { default as FormattedMessage } from './FormattedMessage';



// WEBPACK FOOTER //
// ./src/universal/components/Intl/index.js